import { render, staticRenderFns } from "./AppPhoneInput.vue?vue&type=template&id=10b33bf8&scoped=true"
import script from "./AppPhoneInput.vue?vue&type=script&lang=js"
export * from "./AppPhoneInput.vue?vue&type=script&lang=js"
import style0 from "./AppPhoneInput.vue?vue&type=style&index=0&id=10b33bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b33bf8",
  null
  
)

export default component.exports